import React from "react";
import Buzzed from "../../../../assets/images/verboden/Buzzed.png";
import Profile from "../../../../assets/images/profile.png";

const BuzzledUser = (props) => {
  return (
    <div className="gbs-selected-wrapper text-center">
      <h2 className="mb-0">BUZZED!</h2>
      <img src={Buzzed} alt="Buzzed" className="buzzer-img" />
      <div className="gbs-selected bg-pink">
        <div className="d-flex align-items-center">
          <img
            alt={Profile}
            src={
              (props && props.buzzInfo && props.buzzInfo.profile_image) ||
              Profile
            }
            className="profile-img mx-3"
          />
          <p className="text name mb-0">
            <span>by</span>{" "}
            {(props && props.buzzInfo && props.buzzInfo.display_name) || ""}
          </p>
        </div>
      </div>
    </div>
  );
};

export default BuzzledUser;
